import backgroundLuckyWheelImage from '@/assets/images/backgroundLuckyWheel.jpg';
import backgroundLuckyWheelDeskImage from '@/assets/images/backgroundLuckyWheelDesk.jpg';
import IcatuImage from '@/assets/images/icatuLogo.png';
import SbtPremiosWheelLogo from '@/assets/images/sbtGold.png';
import SbtPremiosLogo from '@/assets/images/SbtPremiosLogo.png';
import { Colors } from '@/brands/sbtPremios/colors';
import { type WhitelabelConfig } from '@/brands/types';
import { LuckySequencyType } from '@/types/enums/HighlightedRaffle';

import type { Metadata } from 'next';

export const sbtPremiosMetaData: Metadata = {
  title: 'SBT Prêmios',
  description: 'Plataforma de apostas',
  metadataBase: new URL('https://sbtpremios.com'),
  openGraph: {
    title: 'SBT Prêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    url: 'https://sbtpremios.com',
    siteName: 'SBT Prêmios',
    images: [
      {
        url: '/images/SbtPremiosLogo.png',
        width: 1200,
        height: 630,
        alt: 'SBT Prêmios',
      },
    ],
    locale: 'pt_BR',
    type: 'website',
  },
  icons: {
    icon: [
      { url: '/favicon.ico', sizes: 'any' },
      { url: '/favicon/favicon-16x16.png', sizes: '16x16', type: 'image/png' },
      { url: '/favicon/favicon-32x32.png', sizes: '32x32', type: 'image/png' },
      { url: '/favicon/favicon-48x48.png', sizes: '48x48', type: 'image/png' },
      { url: '/favicon/favicon-96x96.png', sizes: '96x96', type: 'image/png' },
    ],
    apple: '/favicon/favicon-192x192.png',
  },
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
  twitter: {
    card: 'summary_large_image',
    title: 'SBT Prêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    images: ['/images/SbtPremiosLogo.png'],
  },
};

// TODO: add checkoutCheckboxes in WhitelabelConfig
export const sbtPremiosConfig: WhitelabelConfig = {
  name: 'sbtPremios',
  displayName: 'SBT Prêmios',
  availableGames: [
    LuckySequencyType.LUCKY_WHEEL,
    LuckySequencyType.SCRATCHER,
    LuckySequencyType.SPINNING_TOP,
  ],
  prizesFooterText:
    'São 8 prêmios finais, que somam o valor total de R$ 350.000,00, líquidos de Imposto de renda (25%) e 2058 prêmios instantâneos, que somam o valor total de R$ R$ 105.000,00, líquidos de imposto de Renda (30%)',
  latestWinnersVideos: [
    'https://youtube.com/shorts/LdTbdsFyWQs',
    'https://youtube.com/shorts/xDqVVUei5Lw',
    'https://youtube.com/shorts/B2AtK7-6dqE',
  ],
  assets: {
    logo: SbtPremiosLogo.src,
    logoHeader: SbtPremiosLogo.src,
    logoMenu: SbtPremiosLogo.src,
    logoFooter: SbtPremiosLogo.src,
    logoWheel: SbtPremiosWheelLogo.src,
    luckyWheelBackground: backgroundLuckyWheelImage.src,
    luckyWheelBackgroundDesktop: backgroundLuckyWheelDeskImage.src,
  },
  capitalizer: {
    link: 'https://capitalizacao.icatuseguros.com.br/',
    displayName: 'Icatu Capitalização S.A.',
    logoFooter: IcatuImage.src,
  },
  colors: Colors,
  meta: {
    description: 'SBT Prêmios',
    baseUrl: 'https://sbtpremios.com',
    ogImage: '/images/SbtPremiosLogo.png',
    favicon: '/favicon.ico',
    appleIcon: '/favicon/favicon-192x192.png',
  },
  checkoutCheckboxes: {
    marketingOptIn: {
      visible: true,
      required: false,
      label: 'Aceito receber comunicações de marketing e ofertas',
      errorMessage: 'Você deve aceitar receber comunicações de marketing',
    },
    termsOfService: {
      visible: true,
      required: true,
      label: 'Concordo com os termos',
      errorMessage: 'Você deve concordar com os Termos de Uso',
      prefixText: 'Concordo com a',
      brandText: 'do SBT Prêmios',
      links: [
        { text: 'Política de Privacidade', href: '/politica-de-privacidade' },
        { text: 'Termos de Uso', href: '/termos-de-uso' },
      ],
    },
  },
};
